<!-- dynamic header: user info -->
<!-- breadcrumbs -->
<app-breadcrumbs [breadLinks]="breadLinks"></app-breadcrumbs>
<div class="toggle-button-container">
    <button type="button" class="toggle-drawer-button" mat-button (click)="drawer.toggle()" matTooltip="{{drawer.opened ? 'Nascondi menù' : 'Mostra menù'}}">
        <mat-icon *ngIf="drawer.opened" class="toggle-icon-display" >arrow_left</mat-icon>
        MENU
        <mat-icon *ngIf="!drawer.opened" class="toggle-icon-display" >arrow_right</mat-icon>

      </button>
</div>

<mat-drawer-container class="page-container">

    <mat-drawer #drawer class="sidenav-container" mode="side" opened>
        <internal-side-menu [items]="menuItems" (changeContent)="loadContent()"></internal-side-menu>
    </mat-drawer>
    <mat-drawer-content>

        <app-searchbox *ngIf="showSearchBox && contentTitle" [isAssistenza]="isAssistenza" [title]="contentTitle" [buttonText]="buttonText" [data]="boxSearchData" [name]="sectionName" (newEvent)="newEvent($event)" (searchContent)="loadTable($event)"></app-searchbox>
        <app-datatable *ngIf="tableData" [tableData]="tableData" [pageIndex]="pageIndex"  [pageSize]="pageSize" [paginatorSize]="paginatorSize" [isAssistenza]="isAssistenza"  [cols]="cols" [name]="sectionName" (iconEvent)="iconEvent($event)" (paginationLoad)="paginationLoad($event)"></app-datatable>

    </mat-drawer-content>
</mat-drawer-container>
<!-- dynamic content: filtered search and details -->
